<script>
export default {
  name: 'ArchiveButton',
  emits: ['click'],
  props: {
    size: {
      type: String,
      default: null,
      validator(val) {
        return ['xs', 'sm', 'md', 'lg'].includes(val)
      },
    },
  },
  computed: {
    sizeClass() {
      return this.size ? `btn-${this.size}` : ''
    },
  },
}
</script>

<template lang="pug">
button.btn.btn-warning.text-white(:class="sizeClass" @click="$emit('click', $event)" type="button")
  slot Archive
</template>
